<template>
  <mds-row>
    <mds-col>
      <!-- <mds-button-container right-aligned>
        <router-link :to="{ name: $options.route.EXCHANGE_MONITOR }">
          <mds-button
            variation="flat"
            icon="plus"
            text="Add Exchange Monitor"
          />
        </router-link>
      </mds-button-container> -->
      <store-provider
        v-bind="$options.storeInfo"
        is-paged
      >
        <template v-slot="{ state: filterExchangeMonitors }">
          <mds-table row-hover>
            <mds-thead>
              <mds-th
                v-for="header in $options.headers"
                :key="header.fieldName"
                :style="header.style"
                v-text="header.text"
              />
            </mds-thead>
            <mds-tbody>
              <mds-tr
                v-for="exchangeMonitor in filterExchangeMonitors"
                :key="exchangeMonitor.id"
              >
                <mds-td
                  v-for="header in $options.headers"
                  :key="header.fieldName"
                  :style="header.style"
                >
                  <template v-if="header.fieldName === 'emUrl'">
                    <a
                      :href="exchangeMonitor[header.fieldName]"
                      target="_blank"
                      v-text="exchangeMonitor[header.fieldName]"
                    />
                  </template>
                  <template v-else-if="header.fieldName === 'active'">
                    <status-tag :status="exchangeMonitor[header.fieldName] ? 'ACTIVE' : 'INACTIVE'" />
                  </template>
                  <template v-else-if="header.fieldName === 'actions'">
                    <mds-button-container>
                      <router-link :to="{ name: $options.route.EXCHANGE_MONITOR, params: { id: exchangeMonitor['id'] } }">
                        <mds-button
                          variation="icon-only"
                          icon="create"
                          type="button"
                          text="Edit"
                        />
                      </router-link>
                    </mds-button-container>
                  </template>
                  <template v-else>
                    {{ exchangeMonitor[header.fieldName] }}
                  </template>
                </mds-td>
              </mds-tr>
            </mds-tbody>
          </mds-table>
        </template>
      </store-provider>
    </mds-col>
  </mds-row>
</template>

<script>
import StoreProvider from '@/components/common/StoreProvider';
import StatusTag from '@/components/ui/StatusTag';
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';
import { MdsButton, MdsButtonContainer } from '@mds/button';
import { TABLE_HEADERS } from '@/constants/exchange-monitors.constant';
import { MODULE, COMMON } from '@/constants/store.constant';
import ROUTE from '@/constants/routes.constant';

export default {
  name: 'TableSection',
  components: {
    StoreProvider,
    StatusTag,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsButton,
    MdsButtonContainer,
  },
  data () {
    return {
      url: null,
    };
  },
  storeInfo: {
    module: MODULE.EXCHANGE_MONITORS,
    action: COMMON.FETCH_DATA,
    getter: COMMON.GET_STATE,
  },
  headers: TABLE_HEADERS,
  route: ROUTE,
};
</script>
